/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { ReactNode } from 'react';
import { getClassNameFactory, Button } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';

import './VideoTabList.css';
import { IVideoTabListData } from '../../types';
import {
  ButtonColor,
  ButtonKind,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import { CarrotIcon } from '../PlaylistVideoPlayer/icons/CarrotIcon';
import { CarrotIconUp } from '../PlaylistVideoPlayer/icons/CarrotIconUp';

export const VideoTabListMobile: React.FC<IVideoTabListData> = (props) => {
  const getClassName = getClassNameFactory(VideoTabListMobile.displayName);
  const { playListUserData, currentVideoHandler } = props;

  const [showMenu, setShowMenu] = React.useState(false);

  const convertedData = (dataArray) => {
    return dataArray.map((item) => {
      const entryId = item.entryId;
      const videoTitle = item.videoData?.videoTitle;
      return { label: videoTitle, value: entryId };
    });
  };

  function getObjectByEntryId(entryId) {
    return playListUserData.find((item) => item.entryId === entryId);
  }

  const handleMenuClick = (value: ReactNode) => {
    const currentVideo = getObjectByEntryId(value);
    currentVideo && currentVideoHandler(currentVideo);
    setShowMenu(false);
  };

  const toggleMore = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div className={getClassName()} {...propsToDataAttributes(props)}>
      <Button
        kind={ButtonKind.BUTTON}
        color={ButtonColor.SECONDARY}
        onClick={toggleMore}
        icon={showMenu ? <CarrotIconUp /> : <CarrotIcon />}
        iconPosition={IconPosition.RIGHT}
        block={true}
      >
        Show menu
      </Button>

      {showMenu && (
        <div className={getClassName({ descendantName: 'tab-block' })}>
          <div className={getClassName({ descendantName: 'tab-modal' })}>
            <ul className={getClassName({ descendantName: 'tab-head' })}>
              {convertedData(playListUserData).map((item) => (
                <li key={item.entryId}>
                  <a
                    href="javscript:void(0)"
                    onClick={() => handleMenuClick(item.value)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

VideoTabListMobile.displayName = 'VideoTabListMobile';
